import { co2 } from './common';

export default {
  'consumption.co2': `Mức phát thải ${co2}, kết hợp`,
  'consumption.energy': 'Mức tiêu thụ năng lượng theo chu kỳ kết hợp',
  'consumption.fuel': 'Mức tiêu thụ nhiên liệu, kết hợp',
  'footnotes.local':
    'Các thông số kỹ thuật nêu trên chỉ mang tính tham khảo và có thể thay đổi mà không cần phải thông báo trước. Ngoài ra, các thông tin chứa đựng trong Thông tin Sản phẩm này sẽ không được dùng như là tài liệu hợp đồng đối với một xe cụ thể được bán cho khách hàng trong tương lai.',
  'footnotes.wltp': '',
  'footnotes.nedc': '',
  'footnotes.emissions.appendix':
    'Để biết thêm chi tiết về mức phát thải CO2 và mức tiêu thụ nhiên liệu của xe mới, vui lòng liên hệ các nhà phân phối chính hãng của Mercedes-Benz.',
  'search.input.label': 'Từ khóa tìm kiếm / OnlineCode từ công cụ chọn cấu hình xe',
  'search.result.buy-online': 'Mua online',
  'search.results.count': 'Tìm thấy {count} kết quả',
  'search.results': 'Không tìm thấy kết quả | Tìm thấy {count} kết quả | Tìm thấy {count} kết quả',
  'search.results.backup': 'Không tìm thấy kết quả đúng như từ khóa của bạn. Xem các trang có liên quan:',
  'search.results.none.summary': 'Không có kết quả nào phù hợp cho từ khóa của bạn. Vui lòng nhập từ khóa khác.',
  'search.show-more': 'Hiển thị thêm',
  'search.unavailable': 'Tính năng tìm kiếm hiện không có sẵn.',
  'search.result.new': 'New',
  'input.placeholder': 'Từ khóa tìm kiếm / OnlineCode từ công cụ chọn cấu hình xe',

  'search.result.consumption': 'Mức tiêu thụ',
  'watch.video': 'Xem video',
  'input.recently': 'Được tìm kiếm gần đây',
  'input.help.title': 'Bạn cần tìm cái gì?',
  'input.help.text': 'Tìm kiếm theo loại xe, mẫu xe, mã cấu hình hoặc các phụ kiện, sản phẩm và thông tin khác',

  'search.result.grid': 'Lưới',
  'search.result.list': 'Danh sách',

  //No results
  'support.check': 'Vui lòng kiểm tra lỗi chính tả hoặc thử lại với một thuật ngữ khác.',
  'support.no.results': 'Không có kết quả tìm kiếm nào cho cụm từ tìm kiếm này.',
  'support.no.results.term': 'Không tìm thấy kết quả nào',
  'support.chat': 'Không thể tìm thấy những gì bạn đang tìm kiếm? Vui lòng sử dụng Hỗ trợ trò chuyện ',
  'support.chat.with.us': 'trực tuyến của chúng tôi',
};
